export enum ShopCategory {
  CreatorGoodies = "creator-goodies",
  Experiences = "experiences",
  Donations = "donations",
  Merch = "merch",
}
